import { ChangeDetectionStrategy, Component, HostBinding, HostListener, Input, OnChanges } from '@angular/core';

import { TotalsPrefix } from '@cds/betting-offer';
import { EventModel, EventOption, EventOptionGroup } from '@frontend/sports/betting-offer/feature/model';
import { Sitecore } from '@frontend/sports/common/client-config-data-access';

@Component({
    selector: 'ms-six-pack-option',
    templateUrl: 'six-pack-option.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SixPackOptionComponent implements OnChanges {
    @Input() option: EventOption;
    @Input() optionGroup: EventOptionGroup;
    @Input() event: EventModel;
    @Input() trackingPosition: number;
    @Input() decorateAttribute?: boolean;
    @Input() isHighlighted = false;
    @Input() isAutomatedMarquee?: boolean;
    @HostBinding('class') className = 'six-pack-option';

    attributeValue?: string;
    showAttributeValue: boolean;

    constructor(private sitecore: Sitecore) {}

    @HostListener('click', ['$event'])
    clicked(event: Event): void {
        event.preventDefault();
        event.stopPropagation();
    }

    ngOnChanges(): void {
        if (this.decorateAttribute && this.optionGroup.categoryAttribute && this.option.totalsPrefix) {
            const prefix =
                this.option.totalsPrefix === TotalsPrefix.Over
                    ? this.sitecore.eventGrid.SixPack_TotalsOver
                    : this.sitecore.eventGrid.SixPack_TotalsUnder;

            this.attributeValue = `${prefix} ${this.optionGroup.categoryAttribute}`;
        } else {
            this.attributeValue = this.optionGroup.categoryAttribute || this.option.optionAttribute;
        }

        this.showAttributeValue = !!this.optionGroup.balanced && !!this.attributeValue;

        if (!this.showAttributeValue) {
            this.showAttributeValue = !!this.optionGroup.description;
            this.attributeValue = this.optionGroup.description;
        }
    }
}
